import React from 'react';
import Navigation from './navigation';
import { Link } from 'react-router-dom'

const Header = ( props ) => (

	<header className="mdl-layout--fixed-header">

		<div className="mdl-layout-icon"></div>
		<div className="mdl-layout__header-row">
			<span className="mdl-layout__title"><Link className="dashboard-logo" to="/dashboard">TermsDock</Link></span>
			<div className="mdl-layout-spacer"></div>
			<Navigation/>
			<div className="mdl-navigation">
				{props.user && !props.user.isAnonymous ?
					<div onClick={props.logout} className="mdl-button mdl-button--raised mdl-button--accent">Log Out</div>
					:
					<div onClick={props.login} className="mdl-button mdl-button--raised mdl-button--accent">Log In</div>
				}
			</div>
		</div>
	</header>


)

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js